import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { type UserFilterListItem } from '@repo/utils/src/types/quickFilter';
import { type DataNode } from 'antd/es/tree';

import { LOAD_STORED_STATE, type LoadStoredStateAction } from './constants';

export interface InitialStateType {
  currentSearchConfig: {
    filter: any;
    listName: string;
  };
  currentAppliedSearchConfig: {
    listName: string;
    applied: boolean;
    filter?: UserFilterListItem;
    isOrgLevelFilter?: boolean;
  };
  treeData: any[];
  reorderConfig: {
    isEnabled: boolean;
  };
}

const initialState: InitialStateType = {
  currentSearchConfig: {
    filter: {},
    listName: '',
  },
  currentAppliedSearchConfig: {
    listName: '',
    applied: false,
    isOrgLevelFilter: false,
  },
  treeData: [],
  reorderConfig: {
    isEnabled: false,
  },
};

export const quickFilterSlice = createSlice({
  name: 'manageLeads/quickFilter',
  initialState,
  reducers: {
    toggleReorderState: (state) => {
      state.reorderConfig.isEnabled = !state.reorderConfig.isEnabled;
    },
    updateTreeData: (state, action: PayloadAction<DataNode[]>) => {
      state.treeData = action.payload;
    },
    updateCurrentSearchFilter: (state, action: PayloadAction<any>) => {
      state.currentSearchConfig.filter = action.payload;
    },
    updateCurrentAppliedSearchFilter: (
      state,
      action: PayloadAction<InitialStateType['currentAppliedSearchConfig']>,
    ) => {
      state.currentAppliedSearchConfig = {
        ...state.currentAppliedSearchConfig,
        ...action.payload,
      };
    },
    resetCurrentAppliedSearchFilter: (state) => {
      state.currentAppliedSearchConfig = initialState.currentAppliedSearchConfig;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(LOAD_STORED_STATE, (_, action: LoadStoredStateAction) => ({
      ...initialState,
      ...action.payload.quickFilter,
    }));
  },
});

export const {
  toggleReorderState,
  updateTreeData,
  updateCurrentSearchFilter,
  updateCurrentAppliedSearchFilter,
  resetCurrentAppliedSearchFilter,
} = quickFilterSlice.actions;

export default quickFilterSlice.reducer;
